import { BankRoutes } from '../routes';
import BankAndPsp from '../hoc/bank-and-psp/bank-and-psp';
import BankAndPspList from '../hoc/bank-and-psp/list';
import BankAndPspItemForm from '../hoc/bank-and-psp/item-form';
import BankAndPspInfo from '../hoc/bank-and-psp/info';
import BankAndPspGeneral from '../hoc/bank-and-psp/general';
import PaymentTypesSidepanel from '../hoc/bank-and-psp/payment-type-sidepanel';
import DocumentCreateSidepanel from '../hoc/bank-and-psp/create-document';
import BankAndPspInfoAccountForm from '../hoc/bank-and-psp/info-account-form';
import AccountPage from '../hoc/bank-and-psp/account-page';
import PSPAccounts from '../hoc/bank-and-psp/accounts';
import PSPIntegrations from '../hoc/bank-and-psp/integration';
import PSPExternalAccounts from '../hoc/bank-and-psp/external';
import PSPCreateExternal from '../hoc/bank-and-psp/external-create';
import PSPExternalItem from '../hoc/bank-and-psp/external-item';
import PspIntegrationLogs from '../hoc/bank-and-psp/integration-logs';
import IntegrationLog from '../hoc/bank-and-psp/integration-log';
import LinkedCustomers from '../hoc/bank-and-psp/linked-clients';
import CreateLinkedCustomer from '../hoc/bank-and-psp/create-linked-client';

const BankAndPspRoutes = {
  path: BankRoutes.BANK_AND_PSP,
  element: <BankAndPsp />,
  children: [
    {
      path: BankRoutes.BANK_AND_PSP_LIST,
      element: <BankAndPspList />,
      children: [
        {
          path: BankRoutes.BANK_AND_PSP_CREATE,
          element: <BankAndPspItemForm />,
        },
      ],
    },
    {
      path: BankRoutes.BANK_AND_PSP_PAGE,
      element: <BankAndPspInfo />,
      children: [
        {
          path: BankRoutes.BANK_AND_PSP_GENERAL,
          element: <BankAndPspGeneral />,
          children: [
            {
              path: BankRoutes.BANK_AND_PSP_PAGE_EDIT,
              element: <BankAndPspItemForm />,
            },

            {
              path: BankRoutes.BANK_AND_PSP_PAGE_ADD_DOCUMENTS,
              element: <DocumentCreateSidepanel />,
            },
          ],
        },
        {
          path: BankRoutes.BANK_AND_PSP_ACCOUNTS,
          element: <PSPAccounts />,
          children: [
            {
              path: BankRoutes.BANK_AND_PSP_PAGE_CREATE_ACCOUNT,
              element: <BankAndPspInfoAccountForm />,
            },
          ],
        },
        {
          path: BankRoutes.BANK_AND_PSP_INTEGRATION,
          element: <PSPIntegrations />,
          children: [
            {
              path: BankRoutes.BANK_AND_PSP_PAGE_PAYMENT_TYPES,
              element: <PaymentTypesSidepanel />,
            },
          ],
        },
        {
          path: BankRoutes.BANK_AND_PSP_INTEGRATION_LOGS,
          element: <PspIntegrationLogs />,
          children: [
            {
              path: BankRoutes.BANK_AND_PSP_INTEGRATION_LOGS_ITEM,
              element: <IntegrationLog />,
            },
          ],
        },
        {
          path: BankRoutes.BANK_AND_PSP_EXTERNAL,
          element: <PSPExternalAccounts />,
          children: [
            {
              path: BankRoutes.BANK_AND_PSP_EXTERNAL_CREATE,
              element: <PSPCreateExternal />,
            },
            {
              path: BankRoutes.BANK_AND_PSP_EXTERNAL_ITEM,
              element: <PSPExternalItem />,
            },
          ],
        },
        {
          path: BankRoutes.BANK_AND_PSP_LINKED_CUSTOMERS,
          element: <LinkedCustomers />,
          children: [
            {
              path: BankRoutes.BANK_AND_PSP_LINKED_CUSTOMERS_CREATE,
              element: <CreateLinkedCustomer />,
            },
          ],
        },
      ],
    },
    {
      path: BankRoutes.BANK_AND_PSP_ACCOUNT_PAGE,
      element: <AccountPage />,
      children: [
        {
          path: BankRoutes.BANK_AND_PSP_ACCOUNT_PAGE_EDIT,
          element: <BankAndPspInfoAccountForm />,
        },
        {
          path: BankRoutes.BANK_AND_PSP_ACCOUNT_PAGE_ADD_DOCUMENTS,
          element: <DocumentCreateSidepanel accountPage />,
        },
        {
          path: BankRoutes.BANK_AND_PSP_ACCOUNT_PAGE_EXTERNAL_ACCOUNT,
          element: <PSPExternalItem accountPage />,
        },
      ],
    },
  ],
};

export default BankAndPspRoutes;
